import { withStylePrefix } from '../../common/withStylePrefix';
import { DataTableHeaderCellV2Component, templateDataTableHeaderCellV2 } from './DataTableHeaderCellV2';
import styles from './DataTableHeaderCellV2.styles.scss';
export const chameleonDataTableHeaderCellV2 = DataTableHeaderCellV2Component.compose({
    baseName: 'data-table-header-cell-v2',
    template: templateDataTableHeaderCellV2,
    styles: withStylePrefix(styles),
});
